import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import LineItems from 'modules/finance/components/Invoices/SaleInvoiceDetail/_LineItems'
import Summary from 'modules/finance/components/Quotes/QuotesDetail/_Summary'
import { QuoteDocument } from 'modules/finance/components/Quotes/utils'

interface MainContentProps {
  quote: QuoteDocument
  locale: string
  showQuoteNumber?: boolean
}

const MainContent = ({ quote, locale, showQuoteNumber = false }: MainContentProps) => {
  const saleInvoiceDocument = {
    ...quote,
    documentNumber: quote.quoteNumber,
    dueDate: quote.expirationDate,
    vendor: quote.client,
  }

  return (
    <Box gap="s24" flexDirection="column">
      <SectionHeader title={i18n.t('finance.sale_invoices.detail.summary')} description={''} />
      <Box gap="s16" width="full" paddingLeft="s20">
        <Summary quote={quote} showQuoteNumber={showQuoteNumber} />
        <LineItems locale={locale} saleInvoice={saleInvoiceDocument} />
      </Box>
    </Box>
  )
}

export default MainContent
